/**
 * @group About
 * @summary <blockquote>About page hero & CTA copy.</blockquote>
 */
export const ABOUT_PAGE_CONTENT = {
  hero: {
    title: "Lorem Ipsur",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  cta: {
    title: "Lorem Ipsur",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
} as const; 